export const c_slider__rail_track_before_fill_BackgroundColor_gradient_stop = {
  "name": "--pf-c-slider__rail-track--before--fill--BackgroundColor--gradient-stop",
  "value": "0",
  "var": "var(--pf-c-slider__rail-track--before--fill--BackgroundColor--gradient-stop)"
};
export default c_slider__rail_track_before_fill_BackgroundColor_gradient_stop;